define('controllers/presence/Podio.Controllers.PresenceBar',['require','translate','underscore','jquery','lib/backbone/Backbone.PodioController','views/presence/Podio.Views.Presence.PresenceBar','views/presence/Podio.Views.Presence.UserListModal','collections/Podio.Collections.Contacts','collections/Podio.Collections.Subscriptions','lib/Podio.PresenceBus','lib/Podio.Push','lib/Podio.UI.Tooltips','lib/Podio.UI.Modal','lib/Podio.Config'],function(require) {

  var t = require('translate');
  var _ = require('underscore');
  var $ = require('jquery');
  var PodioController = require('lib/backbone/Backbone.PodioController');

  var PresenceBarView = require('views/presence/Podio.Views.Presence.PresenceBar');
  var UserListModalView = require('views/presence/Podio.Views.Presence.UserListModal');

  var ContactsCollection = require('collections/Podio.Collections.Contacts');
  var SubscriptionsCollection = require('collections/Podio.Collections.Subscriptions');

  var PresenceBus = require('lib/Podio.PresenceBus');
  var PodioPush = require('lib/Podio.Push');
  var Tooltips = require('lib/Podio.UI.Tooltips');
  var modal = require('lib/Podio.UI.Modal');
  var podioConfig = require('lib/Podio.Config');

  return PodioController.extend({

    initialize: function() {
      this.bindAll( 'onViewingPushReceived', 'onTypingPushReceived', 'onSubscriptionPushReceived');

      this._super();

      this.features = this.options.features ? this.options.features : ['comments', 'typing', 'viewers', 'followers'];

      this.model = this.options.model;
      if (!this.model.get('typers')) {
        this.model.set('typers', new ContactsCollection());
      }
      if (!this.model.get('viewers')) {
        this.model.set('viewers', new ContactsCollection());
      }
      this.contactsCollection = new ContactsCollection();
      this.subscriptions = new SubscriptionsCollection();

      this.refType = this.options.refType;

      this.bindEvents();

      this.renderPresenceBar();
    },

    hasFeature: function(feature) {
      return _.include(this.features, feature);
    },

    bindEvents: function() {

      var self = this;
      PodioPush.onPushReady( '/' + this.refType + '/' + this.model.get('id') ).done(function() {
        PresenceBus.enter(self.refType);
      });

      if (this.hasFeature('comments')) {
        this.setupComments();
      }
      if (this.hasFeature('typing')) {
        this.setupTyping();
      }
      if (this.hasFeature('viewers')) {
        this.setupViewers();
      }
      if (this.hasFeature('followers')) {
        this.setupFollowers();
      }

    },

    dispose: function() {
      if (this.presenceBarView) {
        this.presenceBarView.dispose();
      }

      if (this.hasFeature('comments')) {
        this.destroyComments();
      }
      if (this.hasFeature('typing')) {
        this.destroyTyping();
      }
      if (this.hasFeature('viewers')) {
        this.destroyViewers();
      }
      if (this.hasFeature('followers')) {
        this.destroyFollowers();
      }

    },

    reference: function() {
      return {type: this.refType, id: this.model.get('id')};
    },

    setupComments: function() {
      this.eventBus.bind('commentsController:commentAdded', this.onCommentAdded, this);
      this.eventBus.bind('commentsController:commentDeleted', this.onCommentDeleted, this);
      this.eventBus.bind('commentsController:commentViewed', this.onCommentViewed, this);
    },

    destroyComments: function() {
      this.eventBus.unbind('commentsController:commentAdded', this.onCommentAdded);
      this.eventBus.unbind('commentsController:commentDeleted', this.onCommentDeleted);
      this.eventBus.unbind('commentsController:commentViewed', this.onCommentViewed);
    },

    setupTyping: function() {
      this.eventBus.bind('composer:typingStarted', this.onCommentTypingStarted, this);
      this.eventBus.bind('composer:typingStopped', this.onCommentTypingStopped, this);
      PodioPush.on(this.reference(), 'typing', this.onTypingPushReceived, true);
    },

    destroyTyping: function() {
      this.eventBus.unbind('composer:typingStarted', this.onCommentTypingStarted);
      this.eventBus.unbind('composer:typingStopped', this.onCommentTypingStopped);
      PodioPush.off(this.reference(), 'typing', this.onTypingPushReceived);
    },

    setupViewers: function() {
      this.eventBus.bind('presenceBarView:onViewersListTriggered', this.onViewersListTriggered, this);
      PodioPush.on(this.reference(), 'viewing', this.onViewingPushReceived);
    },

    destroyViewers: function() {
      this.eventBus.unbind('presenceBarView:onViewersListTriggered', this.onViewersListTriggered);
      PodioPush.off(this.reference(), 'viewing', this.onViewingPushReceived);
    },

    setupFollowers: function() {
      this.eventBus.bind('presenceBarView:onFollowersListTriggered', this.onFollowersListTriggered, this);
      PodioPush.on(this.reference(), ['subscribe', 'unsubscribe'], this.onSubscriptionPushReceived);
    },

    destroyFollowers: function() {
      this.eventBus.unbind('presenceBarView:onFollowersListTriggered', this.onFollowersListTriggered);
      PodioPush.off(this.reference(), ['subscribe', 'unsubscribe'], this.onSubscriptionPushReceived);
    },

    renderPresenceBar: function() {
      if (!this.presenceBarView) {

        this.presenceBarView = new PresenceBarView({
          elmContainer : this.options.elmContainer ? this.options.elmContainer : $('.presence-bar-wrapper'),
          eventBus: this.eventBus,
          model: this.model,
          stickinessEnabled: this.options.stickinessEnabled,
          features: this.features,
          shouldRenderNewCommentsInfo: this.options.shouldRenderNewCommentsInfo
        });

      }

      Tooltips.hideAll(); // Hide all tooltips, to ensure there isn't any
                          // old-ones left.

      this.presenceBarView.render();
    },

    getSubscriptions: function() {
      return this.subscriptions.getByReference(this.refType, this.model.id);
    },

    onViewingPushReceived: function(pushData) {
      var instance = this;

      var contactsPromise = this.contactsCollection.getContactsByUserIds(pushData);
      contactsPromise.done(function(contacts) {

        instance.model.get('viewers').reset(contacts);
        instance.renderPresenceBar();

      });
    },

    onTypingPushReceived: function(pushData) {
      var instance = this;

      var typingUserIds = _.without(pushData, podioConfig.user.user_id);

      var contactsPromise = this.contactsCollection.getContactsByUserIds(typingUserIds);
      contactsPromise.done(function(contacts) {

        instance.model.get('typers').reset(contacts);
        instance.renderPresenceBar();

      });
    },

    onSubscriptionPushReceived: function(pushData) {
      this.model.set('subscribed_count', pushData.count);
      this.renderPresenceBar();
    },

    onViewersListTriggered: function() {
      var modalView = new UserListModalView({
        collection: this.model.get('viewers'),
        title: t('Viewers #presence-user-list')
      });

      modalView.render();
    },

    onFollowersListTriggered: function() {

      modal.showLoading();

      // Data
      var instance = this;
      this.getSubscriptions().done(function() {

        var modalView = new UserListModalView({
          collection: instance.subscriptions,
          title: t('Followers #presence-user-list')
        });

        modalView.render();

      });
    },

    onCommentAdded: function(commentModel) {
      this.renderPresenceBar();
    },

    onCommentDeleted: function(commentModel) {
      this.renderPresenceBar();
    },

    onCommentViewed: function(comment) {
      this.renderPresenceBar();
    },

    onCommentTypingStarted: function() {
      PresenceBus.enter(this.refType, 'typing');
    },

    onCommentTypingStopped: function() {
      PresenceBus.enter(this.refType, 'viewing');
    }

  });

});

